export const CHANGE_SELECTED_DEVICE_PROFILE = 'CHANGE_SELECTED_DEVICE_PROFILE';

export const changeSelectedDeviceProfile = (profile: any) => ({
    type: CHANGE_SELECTED_DEVICE_PROFILE,
    payload: profile
});
